import { motion } from "framer-motion";

export const PageHeader = ({ overline, title, accent, subtitle }) => (
  <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
    <div className="absolute -top-1/4 left-1/2 -translate-x-1/2 h-[50vh] w-[70vh] rounded-full bg-[#bf953f]/10 blur-[150px]" />
    <div className="absolute top-0 right-0 h-[40vh] w-[40vh] rounded-full bg-[#1a4b9b]/15 blur-[150px]" />
    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37]"
      >
        {overline}
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="mt-4 font-serif-display text-5xl sm:text-6xl md:text-7xl font-medium tracking-tight text-white max-w-4xl"
      >
        {title} {accent && <span className="text-gold-gradient italic">{accent}</span>}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.16 }}
          className="mt-6 max-w-2xl font-body font-light text-base md:text-lg leading-relaxed text-white/60"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
